const antd_less_blue = {
  primaryColor: '#3B70FF', //6
  primaryColorHover: '#6392FF', //5
  primaryColorActive: '#2750D9', //7
  primary1: '#F0F6FF',
  primary2: '#DEEBFF',
  primary3: '#B5D0FF',
  primary4: '#8CB2FF',
  primary5: '#6392FF',
  primary6: '#3B70FF',
  primary7: '#2750D9'
},

 antd_less_red = {
  primaryColor: '#F5222D', //6
  primaryColorHover: '#FF4D4F', //5
  primaryColorActive: '#CF1322', //7
  primary1: '#FFF1F0',
  primary2: '#FFCCC7',
  primary3: '#FFA39E',
  primary4: '#FF7875',
  primary5: '#FF4D4F',
  primary6: '#F5222D',
  primary7: '#CF1322'
},

 antd_less_green = {
  primaryColor: '#52c41a', //6
  primaryColorHover: '#73d13d', //5
  primaryColorActive: '#389e0d', //7
  primary1: '#f6ffed',
  primary2: '#d9f7be',
  primary3: '#b7eb8f',
  primary4: '#95de64',
  primary5: '#73d13d',
  primary6: '#52c41a',
  primary7: '#389e0d'
},
 project_less_blue = {
  '@primary-1': '#F0F6FF',
  '@primary-2': '#DEEBFF',
  '@primary-3': '#B5D0FF',
  '@primary-4': '#8CB2FF',
  '@primary-5': '#6392FF',
  '@primary-6': '#3B70FF',
  '@primary-7': '#2750D9',
  '@primary-8': '#1736B3',
  '@primary-9': '#0B218C',
  '@primary-10': '#071466',
  '@text-color': '#fff',
  '@text-color-dark': 'rgba(0,0,0,0.85)',
  '@bg-color': '#fff'
},

 project_less_red = {
  '@primary-1': '#FFF1F0',
  '@primary-2': '#FFCCC7',
  '@primary-3': '#FFA39E',
  '@primary-4': '#FF7875',
  '@primary-5': '#FF4D4F',
  '@primary-6': '#F5222D',
  '@primary-7': '#CF1322',
  '@primary-8': '#A8071A',
  '@primary-9': '#820014',
  '@primary-10': '#5C0011',
  '@text-color': '#fff',
  '@text-color-dark': 'rgba(0,0,0,0.85)',
  '@bg-color': '#fff'
},

 project_less_green = {
  '@primary-1': '#f6ffed',
  '@primary-2': '#d9f7be',
  '@primary-3': '#b7eb8f',
  '@primary-4': '#95de64',
  '@primary-5': '#73d13d',
  '@primary-6': '#52c41a',
  '@primary-7': '#389e0d',
  '@primary-8': '#237804',
  '@primary-9': '#135200',
  '@primary-10': '#092b00',
  '@text-color': '#fff',
  '@text-color-dark': 'rgba(0,0,0,0.85)',
  '@bg-color': '#fff'
};

export default {
  antd_less_blue,
  antd_less_red,
  antd_less_green,
  project_less_blue,
  project_less_red,
  project_less_green
};
